import {CURRENT_DEVICE_TYPE, DEVICE_DESKTOP, DEVICE_MOBILE} from 'config';

const UserAgent = {
    isMobile() {
        return CURRENT_DEVICE_TYPE === DEVICE_MOBILE;
    },
    isDesktop() {
        return CURRENT_DEVICE_TYPE === DEVICE_DESKTOP;
    },
    isOpera() {
        return (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    },
};

export default UserAgent;
